import { queryBuilder } from '@inpart-io/devtools-iap';
import { RECEIVE_DATA_OBJECTS, REMOVE_DATA_OBJECTS, RETRIEVE_BY_QUERY } from '@inpart-io/devtools-vue';
import { type AssetTypes, briefsManager, type IBrief } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { SAVE_SEARCH_RESULT } from '@/store/base/search/actions';
import { LEAD_MODULE } from '@/store/lead-module';
import { COUNT_LEADS_STATUS_BY_BRIEF } from '@/store/lead-module/actions';

export const RETRIEVE_ALL_BRIEF = 'RETRIEVE_ALL_BRIEF';
export const RETRIEVE_BY_ASSET_TYPE = 'RETRIEVE_BY_ASSET_TYPE';
export const ADD_TAG_ID = 'ADD_TAG_ID';
export const REMOVE_TAG_ID = 'REMOVE_TAG_ID';
export const REASSIGN_LEADS = 'REASSIGN_LEADS';
export const REMOVE_FROM_STORE = 'REMOVE_FROM_STORE';

export const actions: ActionTree<IBrief, unknown> = {
    async [RETRIEVE_ALL_BRIEF](
        context,
        {
            properties,
            includeArchives,
            loadingAggregationsCallback
        }: { properties?: string; includeArchives?: boolean; loadingAggregationsCallback?: () => void }
    ): Promise<number[]> {
        const _comparators = [queryBuilder.cmp.equalTo('isArchived', false)];

        if (includeArchives) {
            _comparators.push(queryBuilder.cmp.isNotNull('dobjId'));
            _comparators.splice(0, 1);
        }

        const query = queryBuilder.build(queryBuilder.op.and(..._comparators), undefined, undefined, [
            {
                attribute: 'name',
                direction: 'ASC'
            }
        ]);
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query,
            properties
        });
        if (idList?.length > 0) {
            await context
                .dispatch(
                    `${LEAD_MODULE}/${COUNT_LEADS_STATUS_BY_BRIEF}`,
                    { query: queryBuilder.build(queryBuilder.op.and(queryBuilder.cmp.isIn('brief', idList))), briefs: idList },
                    { root: true }
                )
                .then(() => {
                    if (loadingAggregationsCallback !== undefined) {
                        loadingAggregationsCallback();
                    }
                });
        }
        await context.dispatch(SAVE_SEARCH_RESULT, { key: 'all', idList });
        return idList;
    },
    async [RETRIEVE_BY_ASSET_TYPE](context, { assetType, properties }: { assetType: AssetTypes; properties?: string }): Promise<void> {
        const _operators = [];
        _operators.push(queryBuilder.cmp.equalToIgnoreCase('allowedAssetTypes', assetType));
        const query = queryBuilder.build(queryBuilder.op.and(..._operators), undefined, undefined, [
            {
                attribute: 'name',
                direction: 'ASC'
            }
        ]);
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query,
            properties
        });
        await context.dispatch(SAVE_SEARCH_RESULT, { key: `byAssetType-${assetType}`, idList });
    },
    async [REASSIGN_LEADS](context, { briefId, reassignLeadOwnerMap }: { briefId: number; reassignLeadOwnerMap: Map<number, number> }) {
        try {
            const result = await briefsManager.reassignLeads(briefId, reassignLeadOwnerMap);
            if (result !== undefined) {
                context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: [result] });
            }
        } catch (e) {
            console.error(e);
        }
    },
    [REMOVE_FROM_STORE](context, { briefId }: { briefId: number }) {
        context.commit(REMOVE_DATA_OBJECTS, { dobjId: briefId });
    }
};
